import { Directive, HostListener, Output, EventEmitter, ElementRef, AfterViewInit, inject } from '@angular/core';
import {AccessibilityService, HotkeyMark, HotkeyType} from '../services/accessibility.service';
import {FocusUtil} from '../utils/focus.util';

@Directive({
    selector: '[a11yHotkeyDelete]',
    standalone: false
})
export class HotkeyDeleteDirective implements AfterViewInit {
    private accessibilityService = inject(AccessibilityService);
    private elementRef = inject(ElementRef);


    // Delete hotkey - Defaults to CTRL-DELETE
    @Output() hotkeyDelete = new EventEmitter<string>();

    ngAfterViewInit() {
        setTimeout(() => {
            FocusUtil.applyHotkeyMarker(this.elementRef.nativeElement, HotkeyMark.hotkeyDelete);
        }, 500); // TODO AC-109
    }

    @HostListener('keydown', ['$event']) onDelete($event){
        if (this.accessibilityService.checkHotkey($event, HotkeyType.DELETE)) {
            $event.preventDefault();
            this.hotkeyDelete.emit();
        }
    }
}
